module.exports = __webpack_public_path__ + "static/logo_white_fr@2x-03a48e260b536a7a8907ef76f7937bad.png";